/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface DeleteFleetsFleetIdMembersMemberIdNotFound
 */
export interface DeleteFleetsFleetIdMembersMemberIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof DeleteFleetsFleetIdMembersMemberIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the DeleteFleetsFleetIdMembersMemberIdNotFound interface.
 */
export function instanceOfDeleteFleetsFleetIdMembersMemberIdNotFound(value: object): value is DeleteFleetsFleetIdMembersMemberIdNotFound {
    return true;
}

export function DeleteFleetsFleetIdMembersMemberIdNotFoundFromJSON(json: any): DeleteFleetsFleetIdMembersMemberIdNotFound {
    return DeleteFleetsFleetIdMembersMemberIdNotFoundFromJSONTyped(json, false);
}

export function DeleteFleetsFleetIdMembersMemberIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFleetsFleetIdMembersMemberIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DeleteFleetsFleetIdMembersMemberIdNotFoundToJSON(json: any): DeleteFleetsFleetIdMembersMemberIdNotFound {
    return DeleteFleetsFleetIdMembersMemberIdNotFoundToJSONTyped(json, false);
}

export function DeleteFleetsFleetIdMembersMemberIdNotFoundToJSONTyped(value?: DeleteFleetsFleetIdMembersMemberIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

